/**
 * Chart Configuration
 * 
 * Configuração centralizada dos gráficos do dashboard.
 * Facilita personalização e manutenção dos gráficos.
 * 
 * @module utils/dashboard/chartConfig
 */

/**
 * Configuração de cores para gráficos
 */
export const chartColors = {
  primary: '#10b981', // emerald-500
  secondary: '#3b82f6', // blue-500
  success: '#22c55e', // green-500
  warning: '#f59e0b', // amber-500
  danger: '#ef4444', // red-500
  info: '#06b6d4', // cyan-500
  purple: '#a855f7', // purple-500
  orange: '#f97316', // orange-500
};

/**
 * Paleta de cores para gráficos de pizza
 */
export const pieChartColors = [
  chartColors.primary,
  chartColors.secondary,
  chartColors.success,
  chartColors.warning,
  chartColors.danger,
  chartColors.info,
  chartColors.purple,
  chartColors.orange,
];

/**
 * Configuração padrão para gráficos de pizza
 */
export const pieChartConfig = {
  colors: pieChartColors,
  innerRadius: 0,
  outerRadius: '80%',
  labelLine: true,
  label: true,
  legend: {
    show: true,
    position: 'bottom',
  },
};

/**
 * Configuração padrão para gráficos de barras
 */
export const barChartConfig = {
  colors: [chartColors.primary],
  barSize: 60,
  margin: {
    top: 20,
    right: 30,
    left: 20,
    bottom: 5,
  },
  legend: {
    show: true,
    position: 'top',
  },
};

/**
 * Configuração para gráfico de distribuição de tarefas
 */
export const taskDistributionConfig = {
  ...pieChartConfig,
  title: 'Distribuição de Tarefas',
  subtitle: 'Últimos 30 dias',
  dataKey: 'total',
  nameKey: 'tipo_tarefa',
  periodo: '30 Dias',
};

/**
 * Configuração para gráfico de status de equipamentos
 */
export const equipmentStatusConfig = {
  ...pieChartConfig,
  title: 'Status dos Equipamentos',
  subtitle: 'Situação atual',
  dataKey: 'total',
  nameKey: 'status',
};

/**
 * Configuração para gráfico de carga de trabalho
 */
export const workloadConfig = {
  ...barChartConfig,
  title: 'Carga de Trabalho por Profissional',
  subtitle: 'Próximos 7 dias',
  dataKey: 'total_tarefas',
  nameKey: 'profissional_nome',
  periodo: 'Próximos 7 dias',
};

export default {
  chartColors,
  pieChartColors,
  pieChartConfig,
  barChartConfig,
  taskDistributionConfig,
  equipmentStatusConfig,
  workloadConfig,
};

